import { TableCellProps } from "@mui/material"

const headCellProps: TableCellProps = {
  align: "center",
  sx: {
    backgroundColor: "#1A428A",
    color: "#fff",
    fontWeight: "bold",
    border: "0.5px solid #E4E4E4",
    boxShadow: " #00000022 1.95px  0px 2.6px",
    paddingY: "12px",
    paddingX: 3,
  },
}

export const defaultTableProps = {
  enableColumnActions: false,
  enableColumnFilters: false,
  enablePagination: false,
  enableSorting: false,
  enableBottomToolbar: false,
  enablePinning: true,
  enableTopToolbar: false,

  muiTablePaperProps: {
    elevation: 0,
  },
  muiTableHeadCellProps: headCellProps,
  muiTableContainerProps: {
    sx: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      position: "absolute",
      borderRadius: "5px",
    },
  },
  muiTableBodyCellProps: {
    sx: {
      height: "60px",
      border: "0.5px solid #E4E4E4",
      boxShadow: "#00000022 1.95px 0px 2.6px",
      color: "black",
    },
  },
  muiTableBodyRowProps: {
    hover: false,
  },
  enableStickyHeader: true,
  enableStickyFooter: true,
}
